import React from 'react';


class ArrowSvg extends React.PureComponent {
  render() {
    const direction = this.props.direction || '';
    let d = null;
    let transform = null;
    if (direction === 'prev') {
      d = 'M3540.53,1210.01l-9.54-10.01,9.54-10.02';
      transform = 'translate(-3530 -1189)';
    } else {
      d = 'M4763.44,1189.98l9.57,10.02-9.57,10.01';
      transform = 'translate(-4761 -1189)';
    }
    return (
      <svg className={`arrowSvg ${direction}`} xmlns="http://www.w3.org/2000/svg" width="12.97" height="22" fill="none" strokeWidth="2px" fillRule="evenodd" stroke={this.props.svgColor} viewBox="0 0 12.97 22">
        <path data-name="elements/arrow.svg" d={d} transform={transform} />
      </svg>
    );
  }
}

export default ArrowSvg;
